import { render, staticRenderFns } from "./PromoView.vue?vue&type=template&id=92ae49da&scoped=true&"
import script from "./PromoView.vue?vue&type=script&lang=js&"
export * from "./PromoView.vue?vue&type=script&lang=js&"
import style0 from "./PromoView.vue?vue&type=style&index=0&id=92ae49da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ae49da",
  null
  
)

/* custom blocks */
import block0 from "@/locales/promo_view.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2F_shared%2FPromo%2FPromoView.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports